<header
  class="dashboard-header d-flex align-items-center justify-content-between position-sticky top-0 pt-4 pb-0 ps-5 pe-0 z-3 mb-4">

  <!-- LEFT: Hamburger (mobile) + Breadcrumb -->
  <div class="d-flex align-items-center gap-3">

    <!-- 🍔 MOBILE SIDEBAR TOGGLE -->
    <button v-if="is_mobile"
      class="btn btn-sm btn-outline-primary rounded-circle d-flex align-items-center justify-content-center"
      @click="$emit('toggle-mobile-sidebar')">
      <i class="bi bi-list"></i>
    </button>

    <!-- Breadcrumb -->
    <div v-if="show_breadcrumb" class="breadcrumb d-flex align-items-center flex-wrap mb-0">

      <template v-if="breadcrumb && breadcrumb.length">
        <span v-if="!show_parent_breadcrumb" class="text-white fw-semibold">
          {{ breadcrumb[breadcrumb.length - 1].title }}
        </span>

        <span v-for="(crumb, i) in breadcrumb" v-else :key="crumb.id + '-' + i" class="d-flex align-items-center">
          <a v-if="i < breadcrumb.length - 1" href="#" @click.prevent="$emit('breadcrumb-click', crumb.id)"
            class="text-white text-decoration-none">
            {{ crumb.title }}
          </a>

          <span v-else class="text-white fw-semibold">
            {{ crumb.title }}
          </span>

          <span v-if="i < breadcrumb.length - 1" class="text-white mx-1">/</span>
        </span>
      </template>

      <span v-else class="text-white fw-semibold ">
        Gauteng Water Command Centre
      </span>

    </div>
  </div>

  <!-- RIGHT: Actions -->
  <ul class="navbar-nav flex-row align-items-center gap-3 pe-4">

    <!-- 🤖 NPI Assistant (DESKTOP ONLY) -->
    <li class="nav-item d-none d-md-block">
      <BolideAssistantButton @open-assistant="openAssistant" />
    </li>

    <!-- User Management -->
    <li class="nav-item">
      <router-link
        to="/user_management"
        class="header-icon-action text-decoration-none"
        aria-label="User Management"
        title="User Management"
      >
        <i class="bi bi-people-fill fs-6"></i>
      </router-link>
    </li>

    <!-- Logout -->
    <li class="nav-item">
      <a href="#" class="nav-link text-white p-0" @click.prevent="logoutUser">
        <i class="bi bi-box-arrow-right fs-6"></i>
      </a>
    </li>

  </ul>

</header>
